import { ModalTitle } from '@dapp/multi-lib/ui/Modal';
import { Modal } from '@dapp/multi-lib/legacy/modal';
import { PANEL_TYPE } from 'utils/constants/common';
import { ButtonV2 } from '@dapp/multi-lib/ui/button';

const SupportModal = ({
  isSupportModalOpen,
  children,
  title,
  handleOnCloseModal,
}: {
  isSupportModalOpen: boolean;
  children: JSX.Element | string;
  handleOnCloseModal: () => void;
  title?: string;
}) => {
  return (
    <Modal
      isOpen={isSupportModalOpen}
      animate
      {...(title && {
        title: (
          <ModalTitle title={title} handleModalClose={handleOnCloseModal} />
        ),
      })}
      content={children}
      secondaryAction={
        <ButtonV2
          variant='default'
          variantStyle='secondary'
          size='small'
          onClick={handleOnCloseModal}
          disabled={false}
        >
          {PANEL_TYPE.CLOSE}
        </ButtonV2>
      }
      overrides={{
        Root: {
          style: () => ({
            zIndex: 999,
          }),
        },
      }}
    />
  );
};

export default SupportModal;
